import React from 'react';
import { observer } from 'owa-mobx-react';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { RibbonThemeV8 } from './RibbonThemeV8';
import { RibbonThemeV9 } from './RibbonThemeV9';
import { initializeIconColorMap, type IconColorMap } from '../../util/getRibbonIconColor';

/**
 * Encapsulates all theme-related logic for Ribbon, including:
 * - Icon color mapping
 * - Fluent UI theme
 * - Next Style and Fluent v9 feature flag integration
 * - Theme initialization
 */
export const RibbonTheme: React.FC<{
    children: React.ReactNode;
    iconColorMap: IconColorMap;
}> = observer(({ children, iconColorMap }) => {
    // Initial rendering will occur when the ribbon definitions are created, so we
    // need to initialize the icon color map first.
    initializeIconColorMap(iconColorMap);

    return isGlobalFeatureEnabled('mon-ribbon-fluent-v9-ribbon') ? (
        <RibbonThemeV9>{children}</RibbonThemeV9>
    ) : (
        <RibbonThemeV8>{children}</RibbonThemeV8>
    );
}, 'RibbonTheme');
